export default __webpack_public_path__ + "static/media/register.66f79223.png";